import { ScaleProps, useScaleProps } from '../../utils/scaleUtils'
import { MediaVideo, MediaVideoProps } from '../base'

export interface Props extends ScaleProps<MediaVideoProps> {}

export default function SMediaVideo({ mediaId, ...props }: Props) {
  const { styleProps, rest } = useScaleProps(props)
  const { w, h } = styleProps
  const dimensions = { height: h, width: w }
  return <MediaVideo mediaId={mediaId} {...dimensions} {...rest} />
}
